module.exports = __webpack_public_path__ + "img/start_5.2109d7b7.svg";